import axios from 'axios'

export interface ApiErrorInfo {
  status?: number
  code?: string
  message?: string
}

// бэк кладёт код ошибки в поле code (часть старых экранов читает errorCode)
export function apiError(err: unknown): ApiErrorInfo {
  if (!axios.isAxiosError(err)) return {}
  const data = err.response?.data as { code?: string; errorCode?: string; message?: string } | undefined
  return { status: err.response?.status, code: data?.code ?? data?.errorCode, message: data?.message }
}
